import RtReconciliationSearchMatchedResponseBase from './base/RtReconciliationSearchMatchedResponseBase';

/**
 * @class RtReconciliationSearchMatchedResponse
 * @extends RtReconciliationSearchMatchedResponseBase
 */
class RtReconciliationSearchMatchedResponse extends RtReconciliationSearchMatchedResponseBase {

}

export default RtReconciliationSearchMatchedResponse;
